"use strict";

import $ from "jquery";
import "owl.carousel";
import { dataAttrOptions } from "./slider.helper";

export default function carouselA(scope) {
    const defaults = {
        items: 1,
        margin: 0,
        loop: true,
        smartSpeed: 450,
        autoplay: true,
        autoplayTimeout: 7000,
        navText: ["&nbsp;", "&nbsp;"],
        dots: false,
        autoHeight: true,
        nav: true,
        lazyLoad: true,
    };

    $(scope).each(function () {
        const elm = $(this);
        const settings = dataAttrOptions(defaults, elm.data());

        const owlElm = elm.owlCarousel(settings);

        owlElm.mouseover(function () {
            owlElm.trigger("stop.owl.autoplay");
        });

        owlElm.on("mouseleave", function () {
            owlElm.trigger("play.owl.autoplay");
        });

        const insideImages = elm[0].querySelectorAll("img.lazyload");
        [].forEach.call(insideImages, (image) => {
            image.addEventListener("load", function () {
                owlElm.trigger("refresh.owl.carousel");
            });
        });

        $(window).on("scroll", function () {
            const coruselEndViewPort =
                $(elm).outerHeight() + $(elm).offset().top;

            if ($(window).scrollTop() > coruselEndViewPort) {
                elm.trigger("stop.owl.autoplay");
            } else {
                elm.trigger("play.owl.autoplay");
            }
        });
    });
}
